import { Link, useParams } from "react-router-dom";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import { useState, useEffect } from "react";
import DeleteModal from "../../../components/deleteModal/DeleteModal";

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from "../../../components/basics/Preloading";

const CashDeskPrinter = () => {
  const { branchId, deskId } = useParams();
  const [gridData, setGridData] = useState([]);
  const [allPrinters, setAllPrinters] = useState([]);
  const [salesUnits, setSalesUnits] = useState([]);
  const [showFormModal, setShowFormModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showUnits, setShowUnits] = useState(true);
  const [filterModel, setFilterModel] = useState({
    deskId: deskId,
    title: "",
    size: 20,
    part: 1,
    total: 0,
    parts: 0,
  });
  const [findPrinterFilterModel, setfindPrinterFilterModel] = useState({
    branchId: branchId,
    deskId: deskId,
    title: "",
    size: 20,
    part: 1,
    total: 0,
    parts: 0,
  });
  const [selectPrinterModel, setSelectPrinterModel] = useState({
    id: 0,
    cashDeskId: deskId,
    printerId: 0,
    saleUnitId: 0,
  });

  const getGridData = async () => {
    const resp = await apiMethod.getDeskPrinters(
      filterModel.deskId,
      filterModel.title,
      filterModel.size,
      filterModel.part
    );
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
    }
  };

  const findAllPrinters = async () => {
    const resp1 = await apiMethod.findCashDeskPrinters(
      findPrinterFilterModel.branchId,
      findPrinterFilterModel.deskId,
      findPrinterFilterModel.size,
      findPrinterFilterModel.part,
      findPrinterFilterModel.title
    );
    if (methods.showApiErrors(resp1)) {
      findPrinterFilterModel.total = resp1.total;
      findPrinterFilterModel.parts = methods.calcPageParts(
        resp1.total,
        findPrinterFilterModel.size
      );
      setfindPrinterFilterModel({ ...findPrinterFilterModel });
      setAllPrinters(resp1.data);
    }
  };

  const getSalesUnits = async () => {
    if (salesUnits.length === 0) {
      const resp = await apiMethod.getAllUnits(branchId);
      if (methods.showApiErrors(resp)) setSalesUnits(resp.data);
    }
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getSalesUnits();
      await getGridData();
      setLoading(false);
    };
    bindData();
  }, [branchId, deskId]);

  const showAllPrinters = () => {
    findAllPrinters();
    setShowFormModal(true);
  };

  const selectUnitEvent = (unitId) => {
    selectPrinterModel.saleUnitId = unitId;
    setSelectPrinterModel(selectPrinterModel);
    setShowUnits(false);
  };

  const selectPrinter = async (item) => {
    const updatedModel = { ...selectPrinterModel, printerId: item.id };
    setSelectPrinterModel(updatedModel);
    await addPrinterToCashDesk(updatedModel);
    setShowUnits(true);
    selectPrinterModel.saleUnitId = 0;
    setSelectPrinterModel({ ...selectPrinterModel });
  };

  const addPrinterToCashDesk = async (model) => {
    if (!isValidDevice(model)) return false;
    setLoading(true);
    const resp = await apiMethod.createDeskPrinter(model);
    if (methods.showApiErrors(resp)) {
      await getGridData();
      setShowFormModal(false);
    }
    setLoading(false);
  };

  const isValidDevice = (model) => {
    var errors = [];
    if (model.cashDeskId === 0 || model.cashDeskId === "0") {
      errors.push("شناسه صندوق باید مقدار داشته باشد.");
    }
    if (model.printerId === 0 || model.printerId === "0") {
      errors.push("دستگاه پیرنتر باید انتخاب شده باشد.");
    }
    if (model.saleUnitId === 0 || model.saleUnitId === "0") {
      errors.push("بخش فروش باید انتخاب شده باشد.");
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }

    return true;
  };

  const selectَItemToDelete = (item) => {
    setSelectPrinterModel({ ...selectPrinterModel, id: item.id });
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeDeskPrinter(selectPrinterModel.id);
      if (!methods.showApiErrors(resp)) return false;

      await getGridData();
      setSelectPrinterModel({
        id: 0,
        cashDeskId: deskId,
        printerId: 0,
        saleUnitId: 0,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const closeModal = () => {
    setShowFormModal(false);
    setShowDeleteModal(false);
    setShowUnits(true);
  };

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.deskId = deskId;
    filterModel.title = "";
    filterModel.size = 20;
    filterModel.part = 1;
    setFilterModel({ ...filterModel });
  };

  const resetFindPrinterFilterModel = () => {
    findPrinterFilterModel.branchId = branchId;
    findPrinterFilterModel.deskId = deskId;
    findPrinterFilterModel.title = "";
    findPrinterFilterModel.size = 20;
    findPrinterFilterModel.part = 1;
    setFilterModel({ ...filterModel });
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const searchItemModal = async () => {
    setLoading(true);
    await findAllPrinters();
    setLoading(false);
  };

  const clearSearchModal = async () => {
    setLoading(true);
    resetFindPrinterFilterModel();
    await findAllPrinters();
    setLoading(false);
  };

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterModel.parts < filterModel.part + 1) {
        return false;
      }
      callPager(filterModel.part + 1);
    } else {
      if (filterModel.part === 1) {
        return false;
      }
      callPager(filterModel.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= filterModel.parts; i++) {
      pages.push(
        <li
          key={i}
          className={
            filterModel.part === i ? "page-item active mx-1" : "page-item mx-1"
          }
        >
          <a
            className="page-link circular-pagination"
            onClick={() => {
              callPager(i);
            }}
          >
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className="d-none d-lg-block">
              <Link
                to={`/sale/${branchId}/cashDeskManage`}
                className="text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link
                  to={`/sale/${branchId}/cashDeskManage`}
                  className="link back-link"
                >
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                صندوق / تخصیص پرینتر
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>صندوق / تخصیص پرینتر </p>
            </div>
            <div className="salemain">
              <div className="salesearchsection">
                <div className="row g-1">
                  <div className="col-12 col-md-6 col-lg-4">
                    <label htmlFor="funit" className="form-label">
                      عنوان
                    </label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: "rtl", textAlign: "right" }}
                        value={filterModel.title}
                        onChange={(e) => {
                          setFilterModel({
                            ...filterModel,
                            title: e.target.value,
                            part: 1,
                          });
                        }}
                      />
                      <button
                        type="button"
                        className="btn btn-purple me-1"
                        onClick={searchItem}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-info"
                        onClick={clearSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className="col-12 col-md-2 col-lg-4"></div>
                  <div className="col-12 col-md-4 col-lg-4">
                    <div className="createButton">
                      <button
                        onClick={() => {
                          showAllPrinters();
                        }}
                        className="btn btn-outline-purple custome-btn"
                        type="button"
                      >
                        <span className="align-middle d-inline-block">
                          تخصیص پرینتر
                        </span>{" "}
                        <i className="bi bi-plus-circle align-middle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-responsive saletable">
                <table className="table table-striped table-md">
                  <thead className="align-middle">
                    <tr>
                      <th scope="col vertical-center" width="20px">
                        ردیف
                      </th>
                      <th scope="col vertical-center">عنوان</th>
                      <th scope="col vertical-center">بخش فروش</th>
                      <th scope="col vertical-center" width="50px">
                        عملیات
                      </th>
                    </tr>
                  </thead>
                  <tbody className="align-middle">
                    {gridData.map((item, index) => (
                      <tr key={`${item.id}-${index}`}>
                        <th scope="row">
                          {(filterModel.part - 1) * filterModel.size +
                            index +
                            1}
                        </th>
                        <td>{item.printerTitle}</td>
                        <td>{item.saleUnitTitle}</td>
                        <td className="d-flex align-items-baseline justify-content-center">
                          <button
                            onClick={() => selectَItemToDelete(item)}
                            className="btn btn-sm btn-outline-danger"
                            type="button"
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filterModel.parts > 1 && (
                  <nav aria-label="Page navigation example" className="mt-5">
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPart(false);
                          }}
                        >
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makePagerItems()}
                      <li className="page-item mx-1">
                        <a
                          className="page-link circular-pagination"
                          onClick={() => {
                            movePagerPart(true);
                          }}
                        >
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                )}
              </div>
            </div>
          </>
        }
      </>
    );
  };

  const Modal = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: showFormModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">تخصیص پرینتر</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
            <div className="modal-body">
              {showUnits && (
                <div className="row row-cols-1 row-cols-md-3 row-cols-lg-4 g-2">
                  {salesUnits.map((item, index) => (
                    <div className="col" key={index}>
                      <div className="card h-100 shadow-sm rounded-0">
                        <div
                          className="card-body text-center dropdown-item-filter "
                          onClick={() => {
                            selectUnitEvent(item.id);
                          }}
                        >
                          {item.title}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {!showUnits && (
                <>
                  <div className="mb-4">
                    <Link
                      onClick={() => {
                        setShowUnits(true);
                      }}
                      className="link back-link"
                    >
                      <span>
                        <img src={back} className="" alt="return" />
                      </span>
                      انتخاب بخش فروش
                    </Link>
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <label htmlFor="funit" className="form-label">
                        عنوان
                      </label>
                      <div className="hstack">
                        <input
                          id="searchInput"
                          className="form-control"
                          type="text"
                          aria-label="Add your item here..."
                          style={{ direction: "rtl", textAlign: "right" }}
                          value={findPrinterFilterModel.title}
                          onChange={(e) => {
                            setfindPrinterFilterModel({
                              ...findPrinterFilterModel,
                              title: e.target.value,
                              part: 1,
                            });
                          }}
                        />
                        <button
                          type="button"
                          className="btn btn-purple me-1"
                          onClick={searchItemModal}
                        >
                          <i className="bi bi-search"></i>
                        </button>
                        <button
                          type="button"
                          className="btn btn-outline-info"
                          onClick={clearSearchModal}
                        >
                          <i className="bi bi-arrow-clockwise"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive saletable">
                    <table className="table table-striped table-md">
                      <thead className="align-middle">
                        <tr>
                          <th scope="col vertical-center" width="20px">
                            ردیف
                          </th>
                          <th scope="col vertical-center">عنوان</th>
                          <th scope="col vertical-center"> نام انگلیسی</th>
                          <th scope="col vertical-center"> IP</th>
                          <th scope="col vertical-center" width="50px">
                            عملیات
                          </th>
                        </tr>
                      </thead>
                      <tbody className="align-middle">
                        {allPrinters.map((item, index) => (
                          <tr key={`${item.id}-${index}`}>
                            <th scope="row">
                              {(findPrinterFilterModel.part - 1) *
                                findPrinterFilterModel.size +
                                index +
                                1}
                            </th>
                            <td>{item.title}</td>
                            <td>{item.name}</td>
                            <td>{item.ipAddress}</td>
                            <td className="d-flex align-items-baseline justify-content-center">
                              <button
                                type="button"
                                className="btn btn-sm btn-purple"
                                onClick={() => selectPrinter(item)}
                              >
                                افزودن
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple "
                onClick={closeModal}
              >
                انصراف
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {renderItems()}
      {showFormModal && Modal()}
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeModal}
          deleteItem={deleteItem}
          text={"پرینتر"}
        />
      )}
    </>
  );
};

export default CashDeskPrinter;
